module.exports = __webpack_public_path__ + "img/media-9.eea84b4f.png";